
import { Component, Prop } from 'vue-facing-decorator'
import { ListViewVue } from '@/common/BaseVue'
import {
  getCouponTypeName as couponTypeName,
  getCouponThreshold as couponThreshold,
  getUserCouponContent as userCouponContent,
  getUserCouponStatus as userCouponStatus,
} from '@/common/coupon'

@Component({})
export default class extends ListViewVue {

  @Prop()
  userId: any;

  /** 类组件只有类成员能在模板里访问，模块级 import 要挂到实例上 */
  getCouponTypeName = couponTypeName;
  getCouponThreshold = couponThreshold;
  getUserCouponContent = userCouponContent;
  getUserCouponStatus = userCouponStatus;

  /** 取值对应后端 UserCouponListDto.status 的 @IsIn([1,2,3]) */
  statusList = [
    { name: "可用", value: 1 },
    { name: "已使用", value: 2 },
    { name: "已过期", value: 3 },
  ];

  getTimeText(row) {
    if (!row.startTime && !row.endTime) return "-";
    return `${this.$format(row.startTime)} ~ ${this.$format(row.endTime)}`;
  }

  getCondition() {
    return {
      status: "",
      startTime: "",
      endTime: "",
    }
  }

  resetFilter() {
    this.find(this.getCondition())
  }

  async getList() {
    let data: any = { ...this.mesureData, userId: this.userId };
    // 兜一层：空字符串会让后端 status 校验失败 / 把日期转成 Invalid Date 直接 400
    ['status', 'startTime', 'endTime'].forEach((key) => {
      if (data[key] === '' || data[key] === null || data[key] === undefined) {
        delete data[key];
      }
    });
    return this.$post("/manager/coupon/user-list", data);
  }
}
